
import { defineComponent, onMounted, reactive, toRefs } from "vue";
import { fetchCountries, postNewCustomer } from "@/helpers/api";
import { Companies, Customers } from "@/interfaces/systemsdb";

export default defineComponent({
  name: "NewCustomerModal",
  props: {
    selectedItem: {
      type: Object,
      required: true,
    },
  },
  emits: ["close", "save"],
  setup(props, { emit }) {
    const state = reactive({
      loading: true as boolean,

      // Site config
      countries: [] as string[],
      customerNames: [] as string[],
      customerSubgroups: [] as Customers[],

      // Turbine config
      companies: [] as Companies[],

      saving: false as boolean,

      form: {
        country: null as string | null,
        customer_name: null as string | null,
        customer_department: null as string | null,
      },
      errorMsg: "" as string,
    });

    const loadOptions = async () => {
      state.loading = true;
      try {
        const [countriesData] = await Promise.all([fetchCountries()]);

        state.customerNames = [];
        state.customerSubgroups = [];
        state.countries = countriesData;
      } catch (error) {
        state.errorMsg = error instanceof Error ? error.message : "Failed to load options";
      } finally {
        state.loading = false;
      }
    };

    const save = async () => {
      state.errorMsg = "";
      state.saving = true;

      try {
        await postNewCustomer({ ...state.form });

        emit("save", {
          form: {
            ...state.form,
          },
        });

        emit("close");
      } catch (error) {
        state.errorMsg = error instanceof Error ? error.message : "Failed to save customer";
      } finally {
        state.saving = false;
      }
    };

    const close = () => {
      emit("close");
    };

    onMounted(loadOptions);

    return {
      ...toRefs(state),
      save,
      close,
      postNewCustomer,
    };
  },
});
